// Shared prefill mechanism between Hero booking bar / quickstart and
// the inquiry forms (InquiryForm sheet + ContactForm section).

const KEY = "frostflotte:prefill_inquiry";

export interface InquiryPrefill {
  pickupDate: string;          // ISO date string (YYYY-MM-DD or full ISO)
  returnDate?: string | null;  // optional ISO date string
  source: string;
}

export const writeInquiryPrefill = (data: InquiryPrefill) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* ignore (private mode, quota etc.) */
  }
};

export const consumeInquiryPrefill = (): InquiryPrefill | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw) as InquiryPrefill;
    if (!parsed?.pickupDate) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const peekInquiryPrefill = (): InquiryPrefill | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as InquiryPrefill;
  } catch {
    return null;
  }
};
